export const UNLOCK_NAVIGATION_SECTION_QUERY_KEY =
  "UNLOCKED_NAVIGATION_SECTION_QUERY_KEY";
